import { timeline as timeline15, animate as animate17, inView as inView13 } from 'vendor';
var reduceMotion2 = window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

if (!window.customElements.get('press-carousel')) {
    var PressCarousel = class extends window.EffectCarousel {
        constructor() {
            super();
            if (reduceMotion2) {
                inView13(this, this._reveal.bind(this));
            }
        }
        _reveal() {
            animate17(
                this.selectedSlide.querySelector('.blockquote'),
                { opacity: 1, transform: ['translateY(15px)', 'translateY(0)'] },
                { duration: 0.2 }
            );
        }
        async _transitionTo(fromSlide, toSlide, options = {}) {
            await timeline15([
                [fromSlide.querySelectorAll('.press__logo, .press__author'), { opacity: [null, 0] }, { duration: 0.2 }],
                [
                    fromSlide.querySelector('.blockquote'),
                    { opacity: [null, 0], ...(reduceMotion2 && { transform: [null, 'translateY(-10px)'] }) },
                    { duration: 0.2, at: '<' },
                ],
            ]).finished;
            fromSlide.classList.remove('is-selected');
            toSlide.classList.add('is-selected');
            await timeline15([
                [toSlide.querySelectorAll('.press__logo, .press__author'), { opacity: [0, 1] }, { duration: 0.2 }],
                [
                    toSlide.querySelector('.blockquote'),
                    { opacity: [0, 1], ...(reduceMotion2 && { transform: ['translateY(10px)', 'translateY(0px)'] }) },
                    { duration: 0.2, at: '<' },
                ],
            ]).finished;
        }
    };
    window.customElements.define('press-carousel', PressCarousel);
}